import { CREATE_YOUTUBE_CHANNELS_SUCCESS } from '../constants/actionTypes';

const INITIAL_STATE = { channels: {}, errors: null };

export default function ytChannels(state=INITIAL_STATE, action) {
 
  switch(action.type) {
    case CREATE_YOUTUBE_CHANNELS_SUCCESS:
      
      const parsedData = JSON.parse(action.payload.data)
      return { ...state, channels: parsedData, errors: null }
    default:
      return state;
  }
}